import { FunctionalComponent, h } from '@stencil/core'
import { GameStore } from 'src/gamification/ui'

import { IBanner } from '../app'
import { IUser } from '../page/admin/types'

export const BannerModal: FunctionalComponent<{
  currentUser: IUser
  banner: IBanner
  startTestCallUrl: string
  scheduleCallUrl: string
  onClosed?: () => void
}> = ({ currentUser, banner, startTestCallUrl, scheduleCallUrl, onClosed }) => {
  if (!banner) {
    return
  }

  if (banner.type === 'prompt' && banner.messageType === 'completed_onboarding') {
    return (
      <onboarding-multi-step-modal
        key={banner.id}
        banner={banner}
        onOnboardingModalClosed={onClosed}
        currentUser={currentUser}
        startTestCallUrl={startTestCallUrl}
        scheduleCallUrl={scheduleCallUrl}
        class='z-50'
        {...banner.metadata}
      />
    )
  }
  if (GameStore.state.isEnabled && banner.type === 'success' && banner.message) {
    return <gamification-success-modal key={banner.id} banner={banner} onClosed={onClosed} class='z-50' />
  }
  if (banner.type === 'prompt' && banner.messageType === 'completed_team_onboarding') {
    return <team-onboarding-education-modal key={banner.id} banner={banner} onClosed={onClosed} class='z-50' />
  }
}
